import PageCover from 'elements/PageCover'
import React from 'react'
import EnquiriesModal from '../../../components/Sales/Enquiries/EnquiriesModal'
import List from '../../../components/Sales/Enquiries/List'
import useTitle from '../../../elements/Hooks/useTitle'

function Enquiries(props) {
  useTitle('Enquiries')
  return (
    <PageCover
      {...{
        title: 'Enquiries',
        subtitle: 'Manage your Enquiries',
        color: '#633570',
        iconType: 'message',
        breadcrumb: [{ text: 'Clients', link: '/clients' }, { text: 'Enquiries' }],
      }}>
      <EnquiriesModal {...props} />
      <List {...props} />
    </PageCover>
  )
}

export default Enquiries
